import {
    GET_VIDEOS_GALLERY,
    GET_VIDEOS_LOADING
} from "../actions";

const initialState = {
    isLoading: false,
    videosList: {}
};

const videoGalleryReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_VIDEOS_LOADING:
            return {
                ...state,
                isLoading: action.payload,
            };
        case GET_VIDEOS_GALLERY:
            return {
                ...state,
                videosList: action.videos,
            };
        default:
            return state;
    }
};

export default videoGalleryReducer;
